import React from 'react';

import { ReactComponent as RedirectIcon } from 'pages/Teachers/StudentListV2/assets/redirect-icon.svg';

import styles from './styles.module.scss';

const ProgressBar = ({
  student,
  currentPoints,
  maxPoints,
  isSubRow = false,
  handleRowClick
}) => {
  const percentage = (currentPoints / maxPoints) * 100;

  let colorClass = styles.fillGreen;
  if (percentage < 40) colorClass = styles.fillRed;
  else if (percentage < 70) colorClass = styles.fillYellow;

  // TODO: remove and show actual currentPoints in next PRD
  const hideScore = true;

  return (
    <div className={styles.progressWrapper}>
      <div className={styles.score}>
        {!hideScore && (
          <>
            <div className={styles.barTrack}>
              <div
                className={`${styles.barFill} ${colorClass}`}
                style={{ width: `${percentage}%` }}
              />
            </div>
            <span className={styles.progressText}>
              {student.score_text
                ? student.score_text
                : `${currentPoints} / ${maxPoints}`}
            </span>
          </>
        )}
      </div>

      {(!student.is_expandable || isSubRow) && (
        <RedirectIcon
          className={styles.redirectIcon}
          onClick={handleRowClick}
        />
      )}
    </div>
  );
};

export default ProgressBar;
